import { render, staticRenderFns } from "./paper-highest-score-report.vue?vue&type=template&id=c596a38c"
import script from "./paper-highest-score-report.vue?vue&type=script&lang=js"
export * from "./paper-highest-score-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports